/* Display-only subscriber to Dawn's resolved variant event. Commerce stays native. */
class CubicoHulkenSpecifications extends HTMLElement {
  connectedCallback() {
    if (this.unsubscribe || typeof subscribe !== 'function') return;
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (String(data.sectionId) !== this.dataset.section) return;
      const source = data.html.getElementById(this.id);
      if (!source) return;
      this.innerHTML = source.innerHTML;
      this.dataset.size = source.dataset.size;
    });
  }
  disconnectedCallback() {
    this.unsubscribe?.();
    this.unsubscribe = null;
  }
}
if (!customElements.get('cubico-hulken-specifications')) {
  customElements.define('cubico-hulken-specifications', CubicoHulkenSpecifications);
}
